/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { Field } from 'SourceUtil/Query';

export function _getProductLabelsField() {
    return new Field('sf_labels');
}

export function addProductLabelFieldsToProductQuery(args, callback) {
    return ([
        ...callback(...args),
        _getProductLabelsField()
    ]);
}

export default {
    'Query/ProductList/Query': {
        'member-function': {
            _getProductInterfaceFields: addProductLabelFieldsToProductQuery
        }
    }
};
